import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowDropDown as ArrowDownIcon, ArrowDropUp as ArrowUpIcon, ArrowRight as ArrowRightIcon, } from '@mui/icons-material';
import { Chip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles';
// TODO: Refactor this component to, investigate use of infinity?
export const PercentagePill = ({ variant = 'filled', value, small = false, text, sx = {}, }) => {
    const { t: translate } = useTranslation();
    const percentage = `${Math.abs(value).toFixed(0)}`;
    let label = `${percentage}%`;
    if (text)
        label += ' ' + text;
    const chipStyle = small ? styles.smallChip : styles.bigChip;
    const size = small ? 'small' : 'medium';
    switch (true) {
        case value === Infinity:
            return (_jsx(Chip, { label: '-', variant: variant, icon: _jsx(ArrowUpIcon, {}), size: size, sx: {
                    ...styles.salesUpChip,
                    ...chipStyle,
                    ...sx,
                } }));
        case percentage == '99999':
            return (_jsx(Chip, { label: '-', variant: variant, icon: _jsx(ArrowUpIcon, {}), size: size, sx: {
                    ...styles.salesUpChip,
                    ...chipStyle,
                    ...sx,
                } }));
        case percentage == '0':
            return (_jsx(Chip, { label: label, variant: variant, icon: _jsx(ArrowRightIcon, {}), size: size, sx: {
                    ...styles.salesEqualChip,
                    ...chipStyle,
                    ...sx,
                } }));
        case value === -Infinity:
            return (_jsx(Chip, { label: '-', variant: variant, icon: _jsx(ArrowDownIcon, {}), size: size, sx: {
                    ...styles.salesDownChip,
                    ...chipStyle,
                    ...sx,
                } }));
        case value < 0:
            return (_jsx(Chip, { label: label, variant: variant, icon: _jsx(ArrowDownIcon, { titleAccess: translate('ICONS.DOWN') }), size: size, sx: {
                    ...styles.salesDownChip,
                    ...chipStyle,
                    ...sx,
                } }));
        case value > 0:
        default:
            return (_jsx(Chip, { label: label, variant: variant, icon: _jsx(ArrowUpIcon, { titleAccess: translate('ICONS.UP') }), size: size, sx: {
                    ...styles.salesUpChip,
                    ...chipStyle,
                    ...sx,
                } }));
    }
};
